import _ from "lodash";

export const supportedFonts = ["Inter", "Courier Prime", "B612 Mono", "B612"] as const;
export type SupportedFont = (typeof supportedFonts)[number];

export const fontFamilyLabels: Record<string, SupportedFont> = {
  Sans: "Inter",
  Courier: "Courier Prime",
  Mono: "B612 Mono",
  B612: "B612",
} as const;

export const fontSelections = _.toPairs(fontFamilyLabels).map(([k, v]) => ({
  label: k,
  value: v,
}));

export function isSupportedFont(f: string): f is SupportedFont {
  return supportedFonts.includes(f as SupportedFont);
}

export function migrateFontFamily(fontFamily: string): SupportedFont {
  if (isSupportedFont(fontFamily)) return fontFamily;
  if (fontFamily === "Courier") return "Courier Prime";
  return "Inter";
}
